const prefix = '';

export default {
    home: `${prefix}/home`,
    loading: `${prefix}/loading`,
    login: `${prefix}/login`,
    loginIB: `${prefix}/loginIB`,
    loginAsCustomer: `${prefix}/loginAsCustomer`,
    autoLogin: `${prefix}/autoLogin`,
    loginSessionId: `${prefix}/login-session-id`,
    registration: `${prefix}/registration`,
    registrationInvesting: `${prefix}/registrationInvesting`,
    forgotPassword: `${prefix}/forgotPassword`,
    resetPassword: `${prefix}/resetPassword/:token/:ref`,
    confirmation: `${prefix}/confirmation/:id/:ref`,
    notFound: `${prefix}/not-found`,
    watchlistItem: (id: number) => `${prefix}/dashboard/${id}`,
    editFavoritesList: `${prefix}/watchList/:id/edit`,
    openTrades: `${prefix}/openTrades`,
    investors: `${prefix}/investors`,
    investments: `${prefix}/investments/:id`,
    favorites: `${prefix}/favorites`,
    followed: `${prefix}/followed`,
    desktop: `${prefix}/desktop`,
    editOpenPosition: `${prefix}/editOpenPosition/:id`,
    editPendingOrder: `${prefix}/editPendingOrder/:id`,
    buySellPosition: `${prefix}/buySellPosition/:symbol`,
    marketOrder: `${prefix}/marketOrder/:symbol/:side`,
    allOrders: `${prefix}/allOrders`,
    result: `${prefix}/result`,
    cash: `${prefix}/cash`,
    deals: `${prefix}/deals`,
    news: `${prefix}/news`,
    uploadDocuments: `${prefix}/uploadDocuments`,
    notifications: `${prefix}/notifications`,
    more: `${prefix}/more`,
    aiStrategy: `${prefix}/aiStrategy`,
    aiStrategyDetails: `${prefix}/aiStrategy/:strategyId`,
    addFunds: `${prefix}/addFunds`,
    addFundsCategory: `${prefix}/addFundsCategory/:amount`,
    addFundsCard: `${prefix}/addFundsCardV2/:provider/:paytikoProvider/:amount`,
    addFundsCardPaymentProvider1: `${prefix}/addFundsCardPaymentProvider1V2/:paymentProvider1Method/:currency/:amount`,
    addFundsCardPaytiko: `${prefix}/addFundsCardPaytiko/:provider/:amount`,
    addFundsCardPaymentProvider1Select: `${prefix}/addFundsCardPaymentProvider1Select/:provider/:amount`,
    addFundsAlternativePayment: `${prefix}/addFundsAlternativePayment/:provider/:method/:amount`,
    addFundsAlternative: `${prefix}/addFundsAlternative/:amount`,
    addFundsBank: `${prefix}/addFundsBank/:amount`,
    commissions: `${prefix}/commissions`,
    chartingLibrary: `${prefix}/chart/:symbol`,
    interestSwap: `${prefix}/interestSwap`,
    withdrawFunds: `${prefix}/withdrawFunds`,
    settings: `${prefix}/settings`,
    accounts: `${prefix}/accounts`,
    verificationCenter: `${prefix}/verificationCenter`,
    changePassword: `${prefix}/changePassword`,
    notificationsSettings: `${prefix}/notificationsSettings`,
    clientReport: `${prefix}/clientReport`,
    resultReport: `${prefix}/resultReport`,
    swapReport: `${prefix}/swapReport`,
    legalDocuments: `${prefix}/legalDocuments`,
    termsOfBusiness: `${prefix}/termsOfBusiness`,
    orderExecutionPolicy: `${prefix}/orderExecutionPolicy`,
    riskDisclosureNotice: `${prefix}/riskDisclosureNotice`,
    privacyPolicy: `${prefix}/privacyPolicy`,
    copyTradingAgreement: `${prefix}/copyTradingAgreement`,
};
